import request from "@/utils/request"; // 导入我们刚刚封装的 axios 实例

/**
 * 获取网站语言配置
 * @returns {Promise}
 */
export function getLanguageSetting() {
  // 注意：这里的路径是后端真实的路径，不需要带 /dev-api
  // 它会自动和 baseURL 拼接
  // 开发时请求地址: /dev-api/api/v1/language (被代理)
  // 生产时请求地址: /api/v1/language (被Nginx代理)
  return request({
    url: "/api/v1/language",
    method: "get",
    showLoading: false,
  });
}
